// extracted by mini-css-extract-plugin
export var sbShowMain = "awards-module--sb-show-main--2UOcQ";
export var wrapper = "awards-module--wrapper--mlpxV";
export var ribbon = "awards-module--ribbon--fbh9c";
export var stars = "awards-module--stars--248jE";
export var star = "awards-module--star--3e1rq";
export var pinkStar = "awards-module--pinkStar--1D52o";
export var box = "awards-module--box--28tn-";
export var awards = "awards-module--awards--34qnt";